import { PresetUser } from '../types/auth';

export const presetUsers: PresetUser[] = [
  {
    id: 'federica',
    name: 'Federica',
    data: {
      "mcdonaldsId": '123456789',
      "deviceId": 'DEV_FED_001',
      "deviceToken": 'TOKEN_FED_2024',
      "email": 'federica@mcdonalds.com',
      "firstname": 'Federica',
      "lastname": 'Rossi',
      "nickname": 'FEDEICO'
    }
  },
  {
    id: 'mario',
    name: 'Mario',
    data: {
      "mcdonaldsId": '987654321',
      "deviceId": 'DEV_MAR_001',
      "deviceToken": 'TOKEN_MAR_2024',
      "email": 'mario@mcdonalds.com',
      "firstname": 'Mario',
      "lastname": 'Bianchi',
      "nickname": 'MAARCO'
    }
  },
  {
    id: 'maria',
    name: 'Maria',
    data: {
      "mcdonaldsId": '222222222',
      "deviceId": 'DEV_MAR_001',
      "deviceToken": 'TOKEN_MAR_2024',
      "email": 'maria@mcdonalds.com',
      "firstname": 'Maria',
      "lastname": 'Rossi',
      "nickname": 'MARIA'
    }
  },
  {
    id: 'luca',
    name: 'Luca',
    data: {
      "mcdonaldsId": '111222333',
      "deviceId": 'DEV_LUC_001',
      "deviceToken": 'TOKEN_LUC_2024',
      "email": 'luca@mcdonalds.com',
      "firstname": 'Luca',
      "lastname": 'Verdi',
      "nickname": 'LUCA ADRIAN'
    }
  },
  {
    id: 'giulia',
    name: 'Giulia',
    data: {
      "mcdonaldsId": '444555666',
      "deviceId": 'DEV_GIU_001',
      "deviceToken": 'TOKEN_GIU_2024',
      "email": 'giulia@mcdonalds.com',
      "firstname": 'Giulia',
      "lastname": 'Ferrari',
      "nickname": 'GIULI'
    }
  },
  {
    id: 'andrea',
    name: 'Andrea',
    data: {
      "mcdonaldsId": '777888999',
      "deviceId": 'DEV_AND_001',
      "deviceToken": 'TOKEN_AND_2024',
      "email": 'andrea@mcdonalds.com',
      "firstname": 'Andrea',
      "lastname": 'Romano',
      "nickname": 'ANDRE'
    }
  },
  {
    id: 'elena',
    name: 'Elena',
    data: {
      "mcdonaldsId": '555666777',
      "deviceId": 'DEV_ELE_001',
      "deviceToken": 'TOKEN_ELE_2024',
      "email": 'elena@mcdonalds.com',
      "firstname": 'Elena',
      "lastname": 'Colombo',
      "nickname": 'ELENA'
    }
  },
  {
    id: 'marco',
    name: 'Marco',
    data: {
      "mcdonaldsId": '333444555',
      "deviceId": 'DEV_MRC_001',
      "deviceToken": 'TOKEN_MRC_2024',
      "email": 'marco@mcdonalds.com',
      "firstname": 'Marco',
      "lastname": 'Ricci',
      "nickname": 'MARCO'
    }
  },
  {
    id: 'sara',
    name: 'Sara',
    data: {
      "mcdonaldsId": '666777888',
      "deviceId": 'DEV_SAR_001',
      "deviceToken": 'TOKEN_SAR_2024',
      "email": 'sara@mcdonalds.com',
      "firstname": 'Sara',
      "lastname": 'Conti',
      "nickname": 'SARA'
    }
  },
  {
    id: 'davide',
    name: 'Davide',
    data: {
      "mcdonaldsId": '888999000',
      "deviceId": 'DEV_DAV_001',
      "deviceToken": 'TOKEN_DAV_2024',
      "email": 'davide@mcdonalds.com',
      "firstname": 'Davide',
      "lastname": 'Galli',
      "nickname": 'DAVIDE'
    }
  },
  {
    id: 'random',
    name: 'Random',
    data: {
      "mcdonaldsId": '000000000',
      "deviceId": 'DEV_RND_000',
      "deviceToken": 'TOKEN_RANDOM',
      "email": 'random@mcdonalds.com',
      "firstname": 'Random',
      "lastname": 'User',
      "nickname": 'RandomUser'
    }
  }
]; 